const RElATED_KEY = {
  EXPIRED_AT: 'expired_at',
  HASH: 'hash',
  ACCESSION_NUMBER: 'accession_number',
  MODALITY: 'modality',
  STUDY_DATE: 'study_date',
  VISIT_ID: 'visit_id',
  INSTITUTION: 'institution',
  APP_ID: 'app_id',
  STUDY_INSTANCE_UID: 'study_instance_uid',
  CITIZEN_ID: 'cccd',
};

export function getRelatedParams(queryParams: URLSearchParams) {
  let xParams = '';

  // hash is required
  const hash = queryParams?.get('hash');
  if (!hash) return xParams;
  // patientId is required
  const patientId = queryParams?.get('patient_id');

  xParams = `patient_id=${patientId}`;

  Object.values(RElATED_KEY).forEach(key => {
    const val = queryParams.get(key);
    if (val) {
      xParams += `&${key}=${val}`;
    }
  });
  return xParams;
}

export function transformReport(reportData, study) {
  const createdAt = reportData.created_at?.split('T');

  return {
    // "SpecificCharacterSet": "ISO_IR 100",
    'InstanceCreationDate': createdAt[0].replaceAll('-', ''),
    'InstanceCreationTime': createdAt[1]
      .replaceAll(':', '')
      .replaceAll('Z', ''),
    'SOPClassUID': '1.2.840.10008.5.1.4.1.1.78.6',
    'SOPInstanceUID': reportData?.id,
    // 'StudyDate': '20240124',
    // 'StudyTime': '044021.442967',
    'StudyDateTime': study?.date,
    'AccessionNumber': reportData?.order?.order_group,
    'RetrieveAETitle': 'VINDR',
    'InstanceAvailability': 'ONLINE',
    'Modality': 'RP',
    // "ConversionType": "SD",
    'Manufacturer': 'VinBigData JSC',
    'ReferringPhysicianName': reportData?.submitter?.fullname,
    // "StudyDescription": null,
    'SeriesDescription':
      reportData?.procedure?.name || reportData?.order?.procedure?.name,
    'PatientName': reportData?.visited_patient?.patient_name,
    'PatientID': reportData?.visited_patient?.patient_id,
    // "IssuerOfPatientID": "DCM4CHEE.null.null",
    'PatientBirthDate': reportData?.visited_patient?.birth_date,
    'PatientSex': reportData?.visited_patient?.sex,
    // "PatientAge": null,
    'StudyInstanceUID': study?.studyInstanceUid,
    'SeriesInstanceUID': reportData?.id,
    // "StudyID": null,
    'StudyDescription': study?.description,
    'SeriesNumber': '0',
    'InstanceNumber': '1',
    'ReportData': reportData,
  };
}

export function transformStudy(studyData, StudyInstanceUID) {
  // const createdAt = studyData.created_at?.split('T');
  // console.log(studyData)
  return {
    // "SpecificCharacterSet": "ISO_IR 100",
    // "InstanceCreationDate": createdAt[0].replaceAll('-', ''),
    // "InstanceCreationTime": createdAt[1].replaceAll(':', '').replaceAll('Z', ''),
    'SOPClassUID': '0.0.000.00000.0.0.0.00.0',
    'SOPInstanceUID': 'noimage-' + StudyInstanceUID,
    // "StudyDate": "20240124",
    // "StudyTime": "044021.442967",
    'AccessionNumber': studyData?.order_group?.[0],
    'RetrieveAETitle': 'VINDR',
    'InstanceAvailability': 'ONLINE',
    'Modality': 'EP',
    // "ConversionType": "SD",
    'Manufacturer': 'VinBigData JSC',
    'ReferringPhysicianName': studyData?.order_doctor_name?.[0],
    // "StudyDescription": null,
    'SeriesDescription': 'No image',
    'PatientName': studyData?.patient_name,
    'PatientID': studyData?.patient_id,
    // "IssuerOfPatientID": "DCM4CHEE.null.null",
    'PatientBirthDate': studyData?.patient_birth_date,
    'PatientSex': studyData?.patient_sex,
    // "PatientAge": null,
    'StudyInstanceUID': StudyInstanceUID,
    'SeriesInstanceUID': 'noimage-' + StudyInstanceUID,
    // "StudyID": null,
    'SeriesNumber': '99999',
    'InstanceNumber': '1',
  };
}
